import type { ComponentProps } from 'react';

import Close from '@/public/assets/svg/Icon/Close.svg';

export const IconClose = ({ ...props }: ComponentProps<'svg'>) => {
  return <Close {...props} />;
};
